import { render } from "./Forum-post.vue?vue&type=template&id=b0e6576a&scoped=true&lang=pug"
import script from "./Forum-post.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum-post.vue?vue&type=script&setup=true&lang=js"

import "./Forum-post.vue?vue&type=style&index=0&id=b0e6576a&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e6576a"]])

export default __exports__